import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export const InputErrorMessage = (props) => {
   return props.isErrorVisible && props.errorMessage
      ? <small className='text-danger'>{props.errorMessage}</small>
      : null;
};

InputErrorMessage.propTypes = {
   isErrorVisible: PropTypes.bool.isRequired,
   errorMessage: PropTypes.string,
};

InputErrorMessage.defaultProps = {
   errorMessage: undefined,
};

const withInputErrorMessage = (InputComponent) => {
   const WrappedComponent = (props) => {
      const [isErrorVisible, setIsErrorVisible] = useState(false);

      useEffect(() => {
         setIsErrorVisible(!!props.errorMessage);
      }, [props.errorMessage]);

      return (
         <>
            <InputComponent
               {...props}
               className={isErrorVisible ? `${ props.className } is-invalid` : props.className}
               isErrorVisible={isErrorVisible}
            />
            <InputErrorMessage isErrorVisible={isErrorVisible} errorMessage={props.errorMessage}/>
         </>
      );
   };

   WrappedComponent.propTypes = {
      isTouched: PropTypes.bool,
      errorMessage: PropTypes.string,
      isDisabled: PropTypes.bool,
      className: PropTypes.string,
   };

   WrappedComponent.defaultProps = {
      isTouched: false,
      errorMessage: undefined,
      isDisabled: false,
      className: '',
   };

   return WrappedComponent;
};

export default withInputErrorMessage;
